/**
 * This file is auto-generated from peselValidation.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const invalid = lang => {
    switch (lang) {
        case 'pl':
            return 'Numer PESEL jest nieprawidłowy';
        case 'en':
            return 'PESEL is invalid';
    }
};
//# sourceMappingURL=peselValidation.loc.js.map